export const environment = {
  baseUrl: 'https://dev-dp.databoxtech.io',
  production: false,
  apiBaseUrl: "https://dev-dp.databoxtech.io/api",
  redirectUrl: 'https://dev-dp.databoxtech.io',
  facebookAppID: '359089569880881',
  googleClientID: '68007569875-t10u2m5mqvsn9plnhqq65evru2ubmqkc.apps.googleusercontent.com',
  officeClientID: '571036cf-ec39-4bd9-8723-b773abec449a',
};